import { FormStore, FormValidator } from '@estee/elc-form';
import { action } from 'mobx';

export interface ICashFormStoreAttributes {
  cashType: string;
}

class CashFormStore extends FormStore<ICashFormStoreAttributes> {
  constructor() {
    super({
      formValidator: new FormValidator(),
      initialValues: {
        cashType: '',
      },
    });
  }

  @action
  public updateCashValues(
    cashFormValues: Partial<ICashFormStoreAttributes>,
  ): void {
    this.setValues({
      ...this.values,
      ...cashFormValues,
    });
  }
}

export default CashFormStore;
